import { KnowledgeBaseContainer } from '@evimo/components/knowledgeBase';

export function ComponentSchemaScreen() {
  return <KnowledgeBaseContainer />;
}
